
export class Worker {
  terminate() {}
}
export { Worker as NodeWorker };
export { Worker as NodeWorkerType };
export const parentPort = null;
//# sourceMappingURL=worker_threads-browser.js.map